var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice"},[_c('p',{staticStyle:{"margin":"0"}},[_vm._v("This page has expired, please refresh and try again.")]),_vm._v(" "),_c('div',{staticClass:"btn-link text-right"},[_c('s-btn',{staticClass:"mr-5",attrs:{"link":""},on:{"click":_vm.refresh}},[_vm._v("Refresh")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }